import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { FastTrackEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { Component, Input } from '@angular/core';

import { ProductLoadingScreen } from './product-loading-screen';

@Component({
  selector: 'app-fast-track-loading-screen',
  templateUrl: './fast-track-loading-screen.component.html',
  styleUrls: [],
  standalone: false
})
export class FastTrackLoadingScreenComponent extends ProductLoadingScreen<FastTrackEnterpriseSearchInterface> {
  @Input() animated = true;
  constructor(service: EnterpriseSearchService) {
    super(service, service.searches[ServiceType.FastTrack]);
  }
}
